   <template>
  <v-container fluid grid-list-md>
    <v-card flat>
      <v-card-title primary-title class="primary white--text">
        <h3 color="primary">Monthly Reports</h3>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-expansion-panel>
              <v-expansion-panel-content v-for="(item,i) in filters" :key="i+'monF'">
                <div slot="header">{{item.name}}</div>
                <v-card>
                  <v-card-text v-if="item.type=='select'">
                    <v-select :items="item.options" :label="item.placeholder" v-model="item.model"></v-select>
                  </v-card-text>
                  <v-card-text v-else-if="item.type=='search'">
                    <v-autocomplete
                      :items="item.options"
                      :search-input.sync="item.input"
                      v-model="item.model"
                      class="mx-3"
                      flat
                      hide-no-data
                      hide-details
                      :label="item.placeholder"
                      solo-inverted
                      clearable
                    ></v-autocomplete>
                  </v-card-text>
                  <v-card-text v-else-if="item.type=='number-range'">
                    <v-slider
                      v-model="item.model"
                      thumb-label
                      :label="item.label"
                      :min="item.min"
                      :max="item.max"
                      range
                    ></v-slider>
                  </v-card-text>
                  <v-card-text v-else-if="item.type=='date-range'">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      v-model="item.menu"
                      :nudge-right="40"
                      :return-value.sync="item.start"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="item.model"
                        label="Pick a Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="item.model"
                        no-title
                        scrollable
                        @input="item.menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <v-flex xs12 md9>
            <v-data-table
              :headers="productListHeader"
              :items="filteredProduct"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <b>{{ props.item['.key']}}</b>
                </td>
                <td>
                  <b>{{ props.item['name']}}</b>
                </td>
                <td>
                  <b>{{ props.item['description']}}</b>
                </td>
                <td>
                  <b>{{ props.item['HSN_code']}}</b>
                </td>
                <td>
                  <b>{{ props.item['GST_type']}}</b>
                </td>
                <td>
                  <b>{{ props.item.taxableGST_rate}}</b>
                </td>
                <td>
                  <b>{{ props.item['unit']}}</b>
                </td>
                <td>
                  <b>{{ props.item['quantity']}}</b>
                </td>
                <td>
                  <b>{{ props.item['openingQuantity']}}</b>
                </td>
                <td>
                  <b>{{ props.item['monthlyQuantity']}}</b>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      productListHeader: [
        { text: "Product- ID", value: "Product - ID" },
        { text: "Name", value: "Name" },
        { text: "Description", value: "Description" },
        { text: "HSN code", value: "HSN" },
        { text: "GST Category", value: "GST" },
        { text: "Taxable rate", value: "Taxable" },
        { text: "Unit", value: "Unit" },
        { text: "Quantity", value: "quantity" },
        { text: "Opening Quantity", value: "quantity" },
        { text: "Month Quantity", value: "quantity" }
      ],
      show: true,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      filters: {
        fromDate: {
          name: "From Date",
          model: null,
          type: "date-range",
          placeholder: "Select Date",
          options: [
            {
              text: "",
              value: ""
            }
          ]
        },
        toDate: {
          name: "To Date",
          model: null,
          type: "date-range",
          placeholder: "Select Till Date",
          options: [
            {
              text: "",
              value: ""
            }
          ]
        },
        month: {
          name: "Month",
          model: null,
          type: "select",
          placeholder: "Select Month",
          options: [
            {
              text: "January",
              value: 0
            },
            {
              text: "February",
              value: 1
            },
            {
              text: "March",
              value: 2
            },
            {
              text: "April",
              value: 3
            },
            {
              text: "May",
              value: 4
            },
            {
              text: "June",
              value: 5
            },
            {
              text: "July",
              value: 6
            },
            {
              text: "August",
              value: 7
            },
            {
              text: "September",
              value: 8
            },
            {
              text: "October",
              value: 9
            },
            {
              text: "November",
              value: 10
            },
            {
              text: "December",
              value: 11
            }
          ],
          reportType: ["sale", "purchase"]
        },
        gstPercentage: {
          name: "GST %",
          model: null,
          type: "select",
          placeholder: "Select GST %",
          options: [0, 5, 12, 18, 28]
        },
        gstCategory: {
          name: "GST Category",
          model: null,
          type: "select",
          placeholder: "GST Category",
          options: [
            {
              text: "Exempt",
              value: "EXEMPT"
            },
            {
              text: "Nil Rated",
              value: "NILL"
            },
            {
              text: "Taxable",
              value: "TAXABLE"
            },
            {
              text: "Others",
              value: "OTHER"
            }
          ]
        },
        unit: {
          name: "Units",
          model: null,
          type: "select",
          placeholder: "Units",
          options: units
        },
        quantity: {
          name: "Quantity",
          model: null,
          type: "number-range",
          label: "Quantity",
          min: 0,
          max: 5000
        },
        hsnCode: {
          name: "HSN Code",
          model: null,
          type: "search",
          input: null,
          placeholder: "Search for HSN code",
          options: [
            {
              text: "",
              value: ""
            }
          ]
        },

        openingQuantity: {
          name: "Opening Quantity",
          model: null,
          type: "number-range",
          label: "Opening Quantity",
          min: 0,
          max: 5000
        },
        saleQuantity: {
          name: "Sale Quantity",
          model: null,
          type: "number-range",
          label: "Sale Quantity",
          min: 0,
          max: 5000
        },
        purchaseQuantity: {
          name: "Purchase Quantity",
          model: null,
          type: "number-range",
          label: "Purchase Quantity",
          min: 0,
          max: 5000
        }
      }
    };
  },
  created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
  },
  methods: {},
  watch: {},
  computed: {
    ...mapGlobalGetters(["selectedBrand","brandFinYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),

    productListByBrand() {
      return this.productList.filter(
        item => item["brand"] === this.selectedBrand
      );
    },
    filteredProduct() {
      let products = this.productListByBrand.filter(item =>{

        if (!Object.keys(this.filters).length) {
          return true;
        }

        if (this.filters.gstPercentage.model) {
          if (this.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        } else if(this.filters.gstPercentage.model == 0) {
          if (this.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        }

        if (this.filters.gstCategory.model) {
          if (this.filters.gstCategory.model !== item["GST_type"]) {
            return false;
          }
        }

        if (this.filters.unit.model) {
          if (this.filters.unit.model !== item["unit"]) {
            return false;
          }
        }

        if (this.filters.hsnCode.model) {
          if (this.filters.hsnCode.model !== item["HSN_code"]) {
            return false;
          }
        }

        if (this.filters.quantity.model) {
          if (item["quantity"] >= this.filters.quantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.openingQuantity.model) {
          if (item["openingQuantity"] >= this.filters.openingQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.saleQuantity.model) {
          if (item["saleQuantity"] >= this.filters.saleQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.purchaseQuantity.model) {
          if (item["purchaseQuantity"] >= this.filters.purchaseQuantity.model) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      products.map(p => {
        p["monthlyQuantity"] = undefined;
      });
      let productGroup = products.reduce(function(r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, Object.create(null));
      let filteredInvoices = this.invoices.filter(item => {
        return item["brand"] === this.selectedBrand;
      });

      let toDate = this.filters.toDate.model ? new Date(this.filters.toDate.model).getTime() : null;
      let fromDate = this.filters.fromDate.model ? new Date(this.filters.fromDate.model).getTime() : null;

      filteredInvoices.map(invoice => {
        let invoiceMonth = new Date(invoice.date).getMonth();
        if (
          invoiceMonth <= this.filters.month.model &&
          !invoice.return &&
          Object.keys(productGroup).length &&
          (fromDate ? invoice.date >= fromDate : true) &&
          (toDate ? invoice.date <= toDate : true)
        ) {
          let isBuyer = invoice.isBuyer;
          invoice.items &&
            invoice.items.map(item => {
              if (
                productGroup[item["productId"]][0].monthlyQuantity != undefined
              ) {
                let monthlyQuantity = parseInt(
                  productGroup[item["productId"]][0]["monthlyQuantity"]
                );
                monthlyQuantity += isBuyer
                  ? -parseInt(item.quantity)
                  : parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "monthlyQuantity"
                ] = monthlyQuantity;
              } else {
                productGroup[item["productId"]][0][
                  "monthlyQuantity"
                ] = productGroup[item["productId"]][0].openingQuantity
                  ? productGroup[item["productId"]][0].openingQuantity
                  : 0;
              }
            });
        }
      });
      let results = [];
      Object.keys(productGroup).length &&
        Object.keys(productGroup).map(function(key, index) {
          productGroup[key][".key"] = key;
          results.push(productGroup[key][0]);
        });
      if (results.length) {
        this.show = false;
      } else {
        this.show = true;
      }
      return results;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Reports/MonthlyReports/index.vue